import { extendTheme } from "@chakra-ui/react";
import customTheme from "./styles";
import { breakpoints } from "./foundations/breakpoints";
import { buttonStyles } from "./components/button";
import { badgeStyles } from "./components/badge";
import { linkStyles } from "./components/link";
import { inputStyles } from "./components/input";
import { CardComponent } from "./additions/card/Card";
import { MainPanelComponent } from "./additions/layout/MainPanel";
import { PanelContentComponent } from "./additions/layout/PanelContent";
import { PanelContainerComponent } from "./additions/layout/PanelContainer";
// import { mode } from "@chakra-ui/theme-tools";
export default extendTheme(
  { breakpoints },
  customTheme,
  buttonStyles,
  badgeStyles,
  linkStyles,
  inputStyles,
  CardComponent,
  MainPanelComponent,
  PanelContentComponent,
  PanelContainerComponent
);
